import React from 'react';

const NextSteps = ({ vm }) => {
  const ps = vm.proximosPassos;
  
  const styles = {
    container: {
      marginBottom: '32px',
      padding: '24px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '12px',
      color: 'white'
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '700',
      marginBottom: '12px'
    },
    subtitle: {
      fontSize: '1.125rem',
      fontWeight: '600',
      marginBottom: '8px'
    },
    summary: {
      fontSize: '1rem',
      lineHeight: '1.6',
      marginBottom: '20px',
      opacity: 0.95
    },
    list: {
      paddingLeft: '20px',
      margin: 0
    },
    listItem: {
      marginBottom: '12px',
      lineHeight: '1.6',
      fontSize: '0.9375rem'
    }
  };

  return (
    <section style={styles.container}>
      <h3 style={styles.title}>Próximos Passos</h3>
      <h4 style={styles.subtitle}>{ps.titulo}</h4>
      <p style={styles.summary}>{ps.resumo}</p>
      <ol style={styles.list}>
        {ps.bullets.map((bullet, i) => (
          <li key={i} style={styles.listItem}>{bullet}</li>
        ))}
      </ol>
    </section>
  );
};

export default NextSteps;